// extracted by mini-css-extract-plugin
module.exports = {"Root":"footerLocalBusinessContacts_Root__Cnfic","Logo":"footerLocalBusinessContacts_Logo__3aPjR","Address":"footerLocalBusinessContacts_Address__BxuC0"};